export default "__VITE_ASSET__Bgx2D0ig__"